import type { ReactNode } from 'react'
import { TriangleAlert } from 'lucide-react'

/**
 * Un avertissement de formulaire : ce que l'enregistrement va changer au-delà
 * de l'écran (inscrits, liens partagés…). Partagé par les formulaires de
 * parcours et d'organisation, pour qu'un même avertissement se lise pareil.
 */
function FormWarning({ children }: { children: ReactNode }) {
  return (
    <div role="note" className="flex items-start gap-3 rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-sm">
      <TriangleAlert className="mt-0.5 size-5 shrink-0 text-warning-text" />
      <p>{children}</p>
    </div>
  )
}

export default FormWarning
